const apiRoot = (process.env.NODE_ENV === 'production')
  ? 'https://localfarmsapi.producealliance.com/api'
  : 'http://localhost:59410/api'


export default (apiRoot)



// WEBPACK FOOTER //
// ./src/common/util/api_root.js